import React, { createContext, useContext, useState } from 'react';

type Theme = {
  primary: string;
  secondary: string;
  text: string;
};

const theme: Theme = {
  primary: 'rose-400',
  secondary: 'rose-100',
  text: 'rose-600'
};

type ThemeContextType = {
  theme: Theme;
};

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const value = {
    theme
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}